import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface ISatisFatura_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface ISatisFatura_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  GetInvoiceSalesHeader: any[];
  GetInvoiceSalesHeader_dummy: any[];
  GetInvoiceSalesVendorChar: any[];
  GetInvoiceSalesVendorChar_dummy: any[];
  ListUser: any[];
  ListUser_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  GetCustomerAccounts: any[];
  GetCustomerAccounts_dummy: any[];
  CurrAccShipmentt: any[];
  CurrAccShipmentt_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  GetSubCurrAccDetails: any[];
  GetSubCurrAccDetails_dummy: any[];
  GetProductAttributes_bir: any[];
  GetProductAttributes_bir_dummy: any[];
  GetProductAttributes_iki: any[];
  GetProductAttributes_iki_dummy: any[];
  GetProductAttributes_uc: any[];
  GetProductAttributes_uc_dummy: any[];
  isComp258660Visible: "visible" | "hidden";
  isComp335485Visible: "visible" | "hidden";
  isComp753551Visible: "visible" | "hidden";
  isComp469258Visible: "visible" | "hidden";
  isComp344175Visible: "visible" | "hidden";
  isComp411339Visible: "visible" | "hidden";
  isComp892616Visible: "visible" | "hidden";
  isComp346579Visible: "visible" | "hidden";
  isComp138208Visible: "visible" | "hidden";
  isComp671627Visible: "visible" | "hidden";
}

export class SatisFatura_ScreenBase extends React.PureComponent<
  ISatisFatura_ScreenProps,
  any
> {
  satisfatura_411475_value_kuikaSelectBoxRef: React.RefObject<any>;
  satisfatura_874047_value_kuikaDateRef: React.RefObject<any>;
  satisfatura_78490_value_kuikaDateRef: React.RefObject<any>;
  satisfatura_743045_value_kuikaSelectBoxRef: React.RefObject<any>;
  satisfatura_760966_value_kuikaAutoCompleteRef: React.RefObject<any>;
  satisfatura_893268_value_kuikaAutoCompleteRef: React.RefObject<any>;
  satisfatura_865705_value_kuikaSelectBoxRef: React.RefObject<any>;
  satisfatura_303536_value_kuikaSelectBoxRef: React.RefObject<any>;
  satisfatura_209759_value_kuikaSelectBoxRef: React.RefObject<any>;
  satisfatura_178153_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "f7c3c48d-f83a-4dc5-82cd-6a1184ac337d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 819053, PropertyName: "label", Value: "Profil" },
        { Id: 73275, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 258138, PropertyName: "value", Value: "Satış Faturaları" },
        { Id: 808493, PropertyName: "value", Value: "Genel Filtre" },
        { Id: 456458, PropertyName: "value", Value: "Tarih Filtresi" },
        { Id: 411475, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 763674, PropertyName: "value", Value: "Başlangıç Tarihi" },
        {
          Id: 874047,
          PropertyName: "placeholder",
          Value: "Başlangıç Tarihi Seçiniz...",
        },
        { Id: 236860, PropertyName: "value", Value: "Bitiş Tarihi" },
        {
          Id: 78490,
          PropertyName: "placeholder",
          Value: "Bitiş Tarihi Seçiniz...",
        },
        { Id: 921189, PropertyName: "label", Value: "Filtreyi Uygula" },
        { Id: 89585, PropertyName: "value", Value: "Sevkiyat Tipi Filtresi" },
        { Id: 743045, PropertyName: "placeholder", Value: "Sevkiyat Tipi" },
        { Id: 971144, PropertyName: "value", Value: "Müşteri Filtresi" },
        { Id: 760966, PropertyName: "placeholder", Value: "Müşteri" },
        { Id: 456119, PropertyName: "value", Value: "Alt Müşteri Filtresi" },
        { Id: 893268, PropertyName: "placeholder", Value: "Alt Hesap" },
        { Id: 596666, PropertyName: "value", Value: "Detaylı Filtre" },
        { Id: 323559, PropertyName: "value", Value: "Koleksiyon Filtresi" },
        { Id: 865705, PropertyName: "placeholder", Value: "Koleksiyon" },
        { Id: 656144, PropertyName: "value", Value: "Desen Filtresi" },
        { Id: 303536, PropertyName: "placeholder", Value: "Desen" },
        { Id: 297932, PropertyName: "value", Value: "Ebat Filtresi" },
        { Id: 209759, PropertyName: "placeholder", Value: "Ebat" },
        { Id: 739377, PropertyName: "label", Value: "Temizle" },
        { Id: 695450, PropertyName: "label", Value: "Ara" },
        { Id: 621226, PropertyName: "value", Value: "Alınan Sipariş" },
        { Id: 887540, PropertyName: "value", Value: "adet" },
        { Id: 134337, PropertyName: "value", Value: "metrekare" },
        { Id: 93650, PropertyName: "value", Value: "Sevk Edilen Sipariş" },
        { Id: 275592, PropertyName: "value", Value: "adet" },
        { Id: 449946, PropertyName: "value", Value: "metrekare" },
        { Id: 485715, PropertyName: "value", Value: "Sevk Emri Bekleyen" },
        { Id: 358902, PropertyName: "value", Value: "adet" },
        { Id: 328802, PropertyName: "value", Value: "metrekare" },
        { Id: 500165, PropertyName: "value", Value: "Karşılanmayan Sipariş" },
        { Id: 964954, PropertyName: "value", Value: "adet" },
        { Id: 181791, PropertyName: "value", Value: "metrekare" },
        { Id: 821219, PropertyName: "value", Value: "Toplam Satış Miktarı" },
        { Id: 968795, PropertyName: "value", Value: "Adet" },
        { Id: 126207, PropertyName: "value", Value: "Metrekare" },
        { Id: 648553, PropertyName: "value", Value: "Toplam Satış Tutarı" },
        { Id: 168799, PropertyName: "value", Value: "Fiyat TL" },
        { Id: 349018, PropertyName: "value", Value: "Fiyat Dolar" },
        {
          Id: 218183,
          PropertyName: "value",
          Value: "Koleksiyon Bazında Satış",
        },
        { Id: 836775, PropertyName: "value", Value: "Top 5 Müşteriler" },
        {
          Id: 178153,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 178694, PropertyName: "title", Value: "Title" },
        { Id: 308909, PropertyName: "value", Value: "Unvan" },
        {
          Id: 862586,
          PropertyName: "value",
          Value: "[datafield:vendordescriptionlong]",
        },
        { Id: 341419, PropertyName: "value", Value: "Miktar" },
        { Id: 617218, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 456567, PropertyName: "value", Value: "M2" },
        { Id: 132294, PropertyName: "value", Value: "[datafield:metrekare]" },
        { Id: 405154, PropertyName: "value", Value: "Tutar" },
        { Id: 605111, PropertyName: "value", Value: "[datafield:tutar]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.satisfatura_411475_value_kuikaSelectBoxRef = React.createRef();
    this.satisfatura_874047_value_kuikaDateRef = React.createRef();
    this.satisfatura_78490_value_kuikaDateRef = React.createRef();
    this.satisfatura_743045_value_kuikaSelectBoxRef = React.createRef();
    this.satisfatura_760966_value_kuikaAutoCompleteRef = React.createRef();
    this.satisfatura_893268_value_kuikaAutoCompleteRef = React.createRef();
    this.satisfatura_865705_value_kuikaSelectBoxRef = React.createRef();
    this.satisfatura_303536_value_kuikaSelectBoxRef = React.createRef();
    this.satisfatura_209759_value_kuikaSelectBoxRef = React.createRef();
    this.satisfatura_178153_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      GetInvoiceSalesHeader: [],
      GetInvoiceSalesVendorChar: [],
      ListUser: [],
      GetImage: [],
      ChangeVisibilityOf: "",
      GetCustomerAccounts: [],
      CurrAccShipmentt: [],
      SetValueOf: "",
      GetSubCurrAccDetails: [],
      GetProductAttributes_bir: [],
      GetProductAttributes_iki: [],
      GetProductAttributes_uc: [],
      dataSource_411475: [
        { key: "10", text: "İki Tarih Arası Filtreleme" },
        { key: "8", text: "Ay başından bu yana" },
        { key: "9", text: "Geçen Ay" },
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son 6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
      isComp258660Visible: "hidden",
      isComp335485Visible: "visible",
      isComp753551Visible: "hidden",
      isComp469258Visible: "hidden",
      isComp344175Visible: "hidden",
      isComp411339Visible: "visible",
      isComp892616Visible: "hidden",
      isComp346579Visible: "hidden",
      isComp138208Visible: "hidden",
      isComp671627Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("satisfatura", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.SatisFaturaPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("satisfatura", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("satisfatura", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.SatisFaturaPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  SatisFaturaPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      ProductAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      ProductAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      SubCurrAccCode_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      CustomerAttribute_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      EndDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      kUserId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.ListUser !== undefined
            ? stateVars.ListUser?.length > 0
              ? stateVars.ListUser[0].id
              : null
            : this.state.ListUser?.length > 0
            ? this.state.ListUser[0].id
            : null
        ),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceSalesHeader = result?.data.getInvoiceSalesHeader;
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );
    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );
    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );
    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );
    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );
    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );
    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );
    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );
    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );
    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );
    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );
    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );
    stateVars.GetInvoiceSalesVendorChar =
      result?.data.getInvoiceSalesVendorChar;

    stateVars.ListUser = result?.data.listUser;
    stateVars.GetImage = result?.data.getImage;
    formVars.satisfatura_401265_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.satisfatura_401265_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );

    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );

    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );

    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );

    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );

    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );

    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );

    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );

    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );

    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );

    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );

    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );

    stateVars.dataSource_178153 =
      stateVars.GetInvoiceSalesVendorChar ??
      this.state.GetInvoiceSalesVendorChar;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  SatisFaturaComponent_548561_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SatisFatura",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "181845",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_819053_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SatisFatura",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_73275_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_335485_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp258660Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp335485Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp753551Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_335485_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SatisFaturaComponent_335485_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaComponent_335485_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetCustomerAccounts = result?.data.getCustomerAccounts;

    formVars.satisfatura_760966_value =
      stateVars.GetCustomerAccounts !== undefined
        ? stateVars.GetCustomerAccounts?.length > 0
          ? stateVars.GetCustomerAccounts[0].currAccDescription
          : null
        : this.state.GetCustomerAccounts?.length > 0
        ? this.state.GetCustomerAccounts[0].currAccDescription
        : null;
    formVars.satisfatura_760966_options = stateVars.GetCustomerAccounts;
    stateVars.CurrAccShipmentt = result?.data.currAccShipmentt;

    formVars.satisfatura_743045_options = stateVars.CurrAccShipmentt;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_335485_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_335485_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_743045 =
      stateVars.CurrAccShipmentt ?? this.state.CurrAccShipmentt;
    stateVars.dataSource_743045 =
      stateVars.CurrAccShipmentt ?? this.state.CurrAccShipmentt;
    formVars.satisfatura_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCustomerAccounts !== undefined
        ? stateVars.GetCustomerAccounts?.length > 0
          ? stateVars.GetCustomerAccounts[0].currAccDescription
          : null
        : this.state.GetCustomerAccounts?.length > 0
        ? this.state.GetCustomerAccounts[0].currAccDescription
        : null
    );

    formVars.satisfatura_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetCustomerAccounts !== undefined
        ? stateVars.GetCustomerAccounts?.length > 0
          ? stateVars.GetCustomerAccounts[0].currAccDescription
          : null
        : this.state.GetCustomerAccounts?.length > 0
        ? this.state.GetCustomerAccounts[0].currAccDescription
        : null
    );

    stateVars.dataSource_760966 =
      stateVars.GetCustomerAccounts ?? this.state.GetCustomerAccounts;
    stateVars.dataSource_760966 =
      stateVars.GetCustomerAccounts ?? this.state.GetCustomerAccounts;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_753551_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp258660Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp335485Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp753551Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_411475_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetCustomerAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_865705_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      ProductAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_303536_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      ProductAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_209759_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      SubCurrAccCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_893268_value",
            "value",
            "GetSubCurrAccDetails",
            "subCurrAccCode",
            "subCurrAccCode"
          )
        ),
        "string"
      ),
      CustomerAttribute_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_743045_value",
            "value",
            "CurrAccShipmentt",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      EndDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "SatisFatura/SatisFaturaComponent_411475_onChange",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetInvoiceSalesHeader = result?.data.getInvoiceSalesHeader;
      formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].orderQty1
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].orderQty1
          : null
      );
      formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].orderQty2
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].orderQty2
          : null
      );
      formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
          : null
      );
      formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
          : null
      );
      formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].reserveQty1
          : null
      );
      formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].reserveQty2
          : null
      );
      formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].remainingQty1
          : null
      );
      formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].remainingQty2
          : null
      );
      formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
          : null
      );
      formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
          : null
      );
      formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
          : null
      );
      formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
      );
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.ChangeVisibilityOf =
        await ReactSystemFunctions.changeVisibilityOf(
          this,
          ReactSystemFunctions.convertToTypeByName(
            "isComp469258Visible",
            "string"
          ),
          ReactSystemFunctions.convertToTypeByName("visible", "string")
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.ChangeVisibilityOf =
        await ReactSystemFunctions.changeVisibilityOf(
          this,
          ReactSystemFunctions.convertToTypeByName(
            "isComp469258Visible",
            "string"
          ),
          ReactSystemFunctions.convertToTypeByName("hidden", "string")
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "satisfatura_874047_value",
          "string"
        ),
        "",
        null,
        false
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "satisfatura_78490_value",
          "string"
        ),
        "",
        null,
        false
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange5_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange5_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].orderQty1
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].orderQty1
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange6_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange6_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].orderQty2
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].orderQty2
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange7_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange7_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange7_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange8_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange8_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange8_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange9_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_411475_onChange9_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange9_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].reserveQty1
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange10_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange10_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange10_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].reserveQty2
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange11_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange11_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].remainingQty1
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange12_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange12_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].remainingQty2
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange13_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange13_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange13_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange14_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange14_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange14_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange15_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange15_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange15_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
          : null
      );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange16_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.SatisFaturaComponent_411475_onChange16_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_411475_onChange16_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
        this,
        stateVars.GetInvoiceSalesHeader !== undefined
          ? stateVars.GetInvoiceSalesHeader?.length > 0
            ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
            : null
          : this.state.GetInvoiceSalesHeader?.length > 0
          ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  SatisFaturaComponent_921189_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetCustomerAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_865705_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      ProductAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_303536_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      ProductAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_209759_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      SubCurrAccCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_893268_value",
            "value",
            "GetSubCurrAccDetails",
            "subCurrAccCode",
            "subCurrAccCode"
          )
        ),
        "string"
      ),
      CustomerAttribute_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_743045_value",
            "value",
            "CurrAccShipmentt",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_874047_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_78490_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaComponent_921189_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceSalesHeader = result?.data.getInvoiceSalesHeader;
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );
    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );
    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );
    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );
    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );
    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );
    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );
    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );
    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );
    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );
    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );
    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_921189_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_921189_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );

    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );

    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );

    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );

    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );

    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );

    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );

    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );

    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );

    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );

    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );

    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_743045_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetCustomerAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_865705_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      ProductAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_303536_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      ProductAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_209759_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      SubCurrAccCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_893268_value",
            "value",
            "GetSubCurrAccDetails",
            "subCurrAccCode",
            "subCurrAccCode"
          )
        ),
        "string"
      ),
      CustomerAttribute_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_743045_value",
            "value",
            "CurrAccShipmentt",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_874047_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_78490_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaComponent_743045_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceSalesHeader = result?.data.getInvoiceSalesHeader;
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );
    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );
    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );
    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );
    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );
    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );
    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );
    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );
    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );
    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );
    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );
    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_743045_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_743045_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );

    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );

    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );

    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );

    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );

    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );

    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );

    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );

    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );

    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );

    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );

    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_760966_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetCustomerAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_865705_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      ProductAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_303536_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      ProductAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_209759_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      SubCurrAccCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_893268_value",
            "value",
            "GetSubCurrAccDetails",
            "subCurrAccCode",
            "subCurrAccCode"
          )
        ),
        "string"
      ),
      CustomerAttribute_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_743045_value",
            "value",
            "CurrAccShipmentt",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_874047_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_78490_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      currAccCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetCustomerAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaComponent_760966_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceSalesHeader = result?.data.getInvoiceSalesHeader;
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );
    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );
    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );
    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );
    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );
    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );
    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );
    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );
    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );
    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );
    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );
    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );
    stateVars.GetSubCurrAccDetails = result?.data.getSubCurrAccDetails;

    formVars.satisfatura_893268_options = stateVars.GetSubCurrAccDetails;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_760966_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_760966_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetSubCurrAccDetails !== undefined
            ? stateVars.GetSubCurrAccDetails?.length > 0
              ? stateVars.GetSubCurrAccDetails[0].currAccCode
              : null
            : this.state.GetSubCurrAccDetails?.length > 0
            ? this.state.GetSubCurrAccDetails[0].currAccCode
            : null
        ),
        true
      )
    ) {
      stateVars.ChangeVisibilityOf =
        await ReactSystemFunctions.changeVisibilityOf(
          this,
          ReactSystemFunctions.convertToTypeByName(
            "isComp344175Visible",
            "string"
          ),
          ReactSystemFunctions.convertToTypeByName("visible", "string")
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_760966_onChange2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.SatisFaturaComponent_760966_onChange2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  SatisFaturaComponent_760966_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_893268 =
      stateVars.GetSubCurrAccDetails ?? this.state.GetSubCurrAccDetails;
    stateVars.dataSource_893268 =
      stateVars.GetSubCurrAccDetails ?? this.state.GetSubCurrAccDetails;
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );

    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );

    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );

    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );

    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );

    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );

    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );

    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );

    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );

    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );

    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );

    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_893268_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetCustomerAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_865705_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      ProductAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_303536_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      ProductAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_209759_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      SubCurrAccCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_893268_value",
            "value",
            "GetSubCurrAccDetails",
            "subCurrAccCode",
            "subCurrAccCode"
          )
        ),
        "string"
      ),
      CustomerAttribute_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_743045_value",
            "value",
            "CurrAccShipmentt",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_874047_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_78490_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaComponent_893268_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceSalesHeader = result?.data.getInvoiceSalesHeader;
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );
    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );
    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );
    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );
    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );
    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );
    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );
    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );
    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );
    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );
    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );
    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_893268_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_893268_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );

    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );

    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );

    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );

    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );

    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );

    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );

    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );

    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );

    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );

    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );

    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_411339_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp411339Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp892616Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp346579Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_411339_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  SatisFaturaComponent_411339_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Att03_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      Att05_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaComponent_411339_onClick1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductAttributes_bir = result?.data.getProductAttributes_bir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_411339_onClick2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_411339_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_865705 =
      stateVars.GetProductAttributes_bir ?? this.state.GetProductAttributes_bir;
    stateVars.dataSource_865705 =
      stateVars.GetProductAttributes_bir ?? this.state.GetProductAttributes_bir;

    stateVars.dataSource_303536 =
      stateVars.GetProductAttributes_iki ?? this.state.GetProductAttributes_iki;
    stateVars.dataSource_303536 =
      stateVars.GetProductAttributes_iki ?? this.state.GetProductAttributes_iki;

    stateVars.dataSource_209759 =
      stateVars.GetProductAttributes_uc ?? this.state.GetProductAttributes_uc;
    stateVars.dataSource_209759 =
      stateVars.GetProductAttributes_uc ?? this.state.GetProductAttributes_uc;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_892616_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp411339Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp892616Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp346579Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_865705_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Att03_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_865705_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      Att05_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaComponent_865705_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductAttributes_iki = result?.data.getProductAttributes_iki;

    formVars.satisfatura_303536_options = stateVars.GetProductAttributes_iki;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_865705_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_865705_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp138208Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    stateVars.dataSource_865705 =
      stateVars.GetProductAttributes_bir ?? this.state.GetProductAttributes_bir;
    stateVars.dataSource_865705 =
      stateVars.GetProductAttributes_bir ?? this.state.GetProductAttributes_bir;

    stateVars.dataSource_303536 =
      stateVars.GetProductAttributes_iki ?? this.state.GetProductAttributes_iki;
    stateVars.dataSource_303536 =
      stateVars.GetProductAttributes_iki ?? this.state.GetProductAttributes_iki;

    stateVars.dataSource_209759 =
      stateVars.GetProductAttributes_uc ?? this.state.GetProductAttributes_uc;
    stateVars.dataSource_209759 =
      stateVars.GetProductAttributes_uc ?? this.state.GetProductAttributes_uc;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_303536_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Att03_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_865705_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      Att05_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_303536_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaComponent_303536_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetProductAttributes_uc = result?.data.getProductAttributes_uc;

    formVars.satisfatura_209759_options = stateVars.GetProductAttributes_uc;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_303536_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_303536_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp671627Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    stateVars.dataSource_865705 =
      stateVars.GetProductAttributes_bir ?? this.state.GetProductAttributes_bir;
    stateVars.dataSource_865705 =
      stateVars.GetProductAttributes_bir ?? this.state.GetProductAttributes_bir;

    stateVars.dataSource_303536 =
      stateVars.GetProductAttributes_iki ?? this.state.GetProductAttributes_iki;
    stateVars.dataSource_303536 =
      stateVars.GetProductAttributes_iki ?? this.state.GetProductAttributes_iki;

    stateVars.dataSource_209759 =
      stateVars.GetProductAttributes_uc ?? this.state.GetProductAttributes_uc;
    stateVars.dataSource_209759 =
      stateVars.GetProductAttributes_uc ?? this.state.GetProductAttributes_uc;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_739377_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      ProductAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      ProductAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      SubCurrAccCode_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      CustomerAttribute_0: ReactSystemFunctions.convertToTypeByName(
        "",
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      EndDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaComponent_739377_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceSalesHeader = result?.data.getInvoiceSalesHeader;
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );
    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );
    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );
    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );
    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );
    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );
    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );
    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );
    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );
    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );
    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );
    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_739377_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_739377_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "satisfatura_743045_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
      null,
      "AttributeCode"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "satisfatura_865705_value",
        "string"
      ),
      "",
      null,
      "AttributeCode"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "satisfatura_303536_value",
        "string"
      ),
      "",
      null,
      "AttributeCode"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "satisfatura_209759_value",
        "string"
      ),
      "",
      null,
      "AttributeCode"
    );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp892616Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp411339Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp346579Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "satisfatura_411475_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("3", "string"),
      null,
      "Key"
    );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp469258Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp258660Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp335485Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp753551Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );

    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );

    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );

    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );

    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );

    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );

    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );

    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );

    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );

    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );

    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );

    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_695450_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetCustomerAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_865705_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      ProductAtt05Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_303536_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      ProductAtt07Desc_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_209759_value",
            "value",
            "GetProductAttributes",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      SubCurrAccCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_893268_value",
            "value",
            "GetSubCurrAccDetails",
            "subCurrAccCode",
            "subCurrAccCode"
          )
        ),
        "string"
      ),
      CustomerAttribute_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_743045_value",
            "value",
            "CurrAccShipmentt",
            "attributeCode",
            "attributeCode"
          )
        ),
        "string"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_874047_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_78490_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "SatisFatura/SatisFaturaComponent_695450_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoiceSalesHeader = result?.data.getInvoiceSalesHeader;
    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );
    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );
    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );
    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );
    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );
    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );
    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );
    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );
    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );
    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );
    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );
    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.SatisFaturaComponent_695450_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  SatisFaturaComponent_695450_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.satisfatura_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty1
        : null
    );

    formVars.satisfatura_635089_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].orderQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].orderQty2
        : null
    );

    formVars.satisfatura_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty1
        : null
    );

    formVars.satisfatura_63718_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].shipmentQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].shipmentQty2
        : null
    );

    formVars.satisfatura_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty1
        : null
    );

    formVars.satisfatura_747445_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].reserveQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].reserveQty2
        : null
    );

    formVars.satisfatura_910082_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty1
        : null
    );

    formVars.satisfatura_311331_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].remainingQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].remainingQty2
        : null
    );

    formVars.satisfatura_988182_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty1
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty1
        : null
    );

    formVars.satisfatura_99398_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceQty2
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceQty2
        : null
    );

    formVars.satisfatura_42667_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmount
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmount
        : null
    );

    formVars.satisfatura_271494_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoiceSalesHeader !== undefined
        ? stateVars.GetInvoiceSalesHeader?.length > 0
          ? stateVars.GetInvoiceSalesHeader[0].invoiceAmountU
          : null
        : this.state.GetInvoiceSalesHeader?.length > 0
        ? this.state.GetInvoiceSalesHeader[0].invoiceAmountU
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  SatisFaturaComponent_355047_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "SKoleksiyonBazindaSatis",
      "CustomerCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetCustomerAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SKoleksiyonBazindaSatis",
      "CustomerName",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_760966_value",
            "value",
            "GetCustomerAccounts",
            "currAccCode",
            "currAccDescription"
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SKoleksiyonBazindaSatis",
      "SubCustomerCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_893268_value",
            "value",
            "GetSubCurrAccDetails",
            "subCurrAccCode",
            "subCurrAccCode"
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "SKoleksiyonBazindaSatis",
      "SubCustomerName",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "satisfatura_893268_value",
            "value",
            "GetSubCurrAccDetails",
            "subCurrAccCode",
            "companyName"
          )
        ),
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "SatisFatura",
      "SKoleksiyonBazindaSatis",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [181845, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.SatisFaturaPageInit();
    }
  }
}
